import WebTimeclockNavItem from './WebTimeclockNavItem';

export default WebTimeclockNavItem;
